module.exports = "mutation AddToPlaylist ($trackId: String!) {\n  addTrackToPlaylist (trackId: $trackId) {\n    id\n  }\n}\n"